import { LocalStorageAPI } from 'API/LocalStoreApi';
import { eLocalStorageTags } from 'API/eLocalStorageTags';
import { ISearchBarSettings } from 'types/globalSearchBar/IGlobalSearchBarSettings';

export const GlobalSearchBarSettings = LocalStorageAPI.injectEndpoints({
  endpoints: (build) => ({
    getSettings: build.query<ISearchBarSettings, void>({
      query: () => ({
        url: 'SearchBarSearchSettings',
        method: 'GET',
      }),
      providesTags: [{ type: eLocalStorageTags.GlobalSearchBarSettings }],
    }),
    setSettings: build.mutation<void, ISearchBarSettings>({
      query: (body) => ({
        url: 'SearchBarSearchSettings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [{ type: eLocalStorageTags.GlobalSearchBarSettings }],
    }),
  }),
});

export const { useGetSettingsQuery, useSetSettingsMutation } = GlobalSearchBarSettings;
